class HeaderNew extends HTMLElement {
  private overlay: HTMLElement | null;
  private drawer: HTMLElement | null;
  private toggleButton: HTMLElement | null;
  private closeButton: HTMLElement | null;
  private sideMenuCart: HTMLElement | null;
  private menuToggles: NodeListOf<HTMLElement>;
  private handleKeyDown: (e: KeyboardEvent) => void;
  private handleBreakpointChange: () => void;
  private searchModal: HTMLElement | null;
  private dropdowns: NodeListOf<HTMLElement>;
  private breakpointQuery: MediaQueryList;

  constructor() {
    super();

    this.overlay = this.querySelector("[data-side-menu-overlay]");
    this.drawer = this.querySelector("[data-side-menu-drawer]");
    this.toggleButton = this.querySelector("[data-side-menu-toggle]");
    this.closeButton = this.querySelector("[data-side-menu-close]");
    this.menuToggles = this.querySelectorAll("[data-menu-toggle]");
    this.sideMenuCart = this.querySelector("[data-side-menu-cart]");
    this.searchModal = document.querySelector("#search-modal-new");
    this.dropdowns = this.querySelectorAll(
      "[data-menu-parent].header-new__menu-item",
    );

    this.breakpointQuery = window.matchMedia("(min-width: 992px)");
    this.handleKeyDown = this.onKeyDown.bind(this);
    this.handleBreakpointChange = () => {
      if (this.isMenuOpen()) {
        this.closeMenu();
      }
    };
  }

  connectedCallback(): void {
    if (
      !this.overlay ||
      !this.drawer ||
      !this.toggleButton ||
      !this.closeButton
    ) {
      return;
    }

    this.toggleButton.addEventListener("click", (e) => {
      e.preventDefault();
      this.openMenu();
    });

    this.closeButton.addEventListener("click", (e) => {
      e.preventDefault();
      this.closeMenu();
    });

    this.overlay.addEventListener("click", () => {
      this.closeMenu();
    });

    this.sideMenuCart?.addEventListener("click", () => {
      this.closeMenu();
    });

    this.dropdowns.forEach((dropdown) => {
      dropdown.addEventListener("mouseenter", (e) => {
        e.preventDefault();
        this.searchModal.classList.remove("reveal");
      });
    });

    document.addEventListener("keydown", this.handleKeyDown);

    // Close side menu when crossing the tablet/desktop breakpoint
    this.breakpointQuery.addEventListener("change", this.handleBreakpointChange);

    // Setup submenu toggles
    this.menuToggles.forEach((toggle) => {
      toggle.addEventListener("click", (e) => {
        e.preventDefault();
        this.toggleSubmenu(toggle);
      });
    });
  }

  disconnectedCallback(): void {
    document.removeEventListener("keydown", this.handleKeyDown);
    this.breakpointQuery.removeEventListener("change", this.handleBreakpointChange);
  }

  private onKeyDown(e: KeyboardEvent): void {
    if (e.key === "Escape" && this.isMenuOpen()) {
      this.closeMenu();
    }
  }

  private toggleSubmenu(toggle: HTMLElement): void {
    const menuItem = toggle.closest("[data-menu-item]");
    if (!menuItem) return;

    const isActive = menuItem.classList.contains("active");

    this.querySelectorAll("[data-menu-item].active").forEach((item) => {
      if (item !== menuItem) {
        item.classList.remove("active");
      }
    });

    if (isActive) {
      menuItem.classList.remove("active");
    } else {
      menuItem.classList.add("active");
    }
  }

  private openMenu(): void {
    this.overlay?.classList.add("active");
    this.drawer?.classList.add("active");
    document.body.style.overflow = "hidden";
  }

  private closeMenu(): void {
    this.overlay?.classList.remove("active");
    this.drawer?.classList.remove("active");
    document.body.style.overflow = "";

    this.querySelectorAll("[data-menu-item].active").forEach((item) => {
      item.classList.remove("active");
    });
  }

  private isMenuOpen(): boolean {
    return this.drawer?.classList.contains("active") || false;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "header-new": HeaderNew;
  }
}

if (!window.customElements.get("header-new")) {
  window.customElements.define("header-new", HeaderNew);
}

export {};
